export default __webpack_public_path__ + "static/p-lor-8bc4216ce3a0a54341b82551bce3cc28.png";